module.exports = __webpack_public_path__ + "img/report-black-icon.b00d3682.svg";